import React from 'react';
import './common.css'; // This will be for styling your modal

const AccessDeniedModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <h2>Access Denied</h2>
        <p>You do not have the necessary permissions to access this page.</p>
        <button onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

export default AccessDeniedModal;
